import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class EquitasBankService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }
    getEquitasBankAudit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-equitas-bank-audit', filter, configs)
    }
    getEquitasBankTransactions(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'equitas-bank-transactions', filter, configs)
    }
    // Unused endpoint - not called anywhere in the app
    // saveEquitasBankTransactions(updateData: any) {
    //     const configs = {
    //         withCredentials: true,
    //         headers: { Authorization: `Bearer ${this.getToken()}` },
    //     };
    //     return this.http.post<any>(this.api_url + 'save-equitas-bank-transactions', updateData, configs)
    // }
}


// WEBPACK FOOTER //
// ./src/app/services/equitasbank.service.ts